import BigNumber from 'bignumber.js'

export const BIG_ZERO = new BigNumber(0);
export const BIG_TEN = new BigNumber(10);
